import { render, staticRenderFns } from "./VendorInvoice.vue?vue&type=template&id=60fe2d28&"
import script from "./VendorInvoice.vue?vue&type=script&lang=js&"
export * from "./VendorInvoice.vue?vue&type=script&lang=js&"
import style0 from "./VendorInvoice.vue?vue&type=style&index=0&id=60fe2d28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports